import {Sound} from '@pixi/sound';
import {Texture, LoaderResource} from 'pixi.js';
import {ISkeletonData} from 'pixi-spine';

export type TextureMap = Record<string, Texture>;
export type SoundMap = Record<string, Sound>;
export type SpineMap = Record<string, ISkeletonData>;

export interface Resources {
    textures: TextureMap;
    sounds: SoundMap;
    spines: SpineMap;
}

export type InitialResources = {
    notificationMessage: LoaderResource;
    popup: LoaderResource;
    slotLang: LoaderResource;
};

export enum LoaderPriority {
    BEFORE = 0,
    DEFAULT = 1,
    AFTER = 2,
    NONE = -1
}

export type LoadPriorityName = 'before' | 'default' | 'after';

export enum ResourceLoadPriority {
    before = 'before',
    default = 'default',
    after = 'after',
}

export type ResourcesPack = Partial<Record<ResourceLoadPriority, string>>;

